(() => {
  const parseVariants = (subtotalNode) => {
    const variantsDataNode = subtotalNode.querySelector('[data-subtotal-variants]');
    if (!variantsDataNode) return [];

    try {
      return JSON.parse(variantsDataNode.textContent || '[]');
    } catch (error) {
      return [];
    }
  };

  const getSelectedVariantFromPicker = (subtotalNode) => {
    const productInfo = subtotalNode.closest('product-info');
    const selectedVariantNode = productInfo?.querySelector('[data-selected-variant]');
    if (!selectedVariantNode) return null;

    try {
      return JSON.parse(selectedVariantNode.textContent || 'null');
    } catch (error) {
      return null;
    }
  };

  const formatMoney = (subtotalNode, cents) => {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, window.money_format || subtotalNode.dataset.moneyFormat);
    }

    const amount = (Number(cents) / 100).toFixed(2);
    return `${amount} ${subtotalNode.dataset.currencyCode || ''}`.trim();
  };

  const getSectionIds = (subtotalNode) => {
    const productInfo = subtotalNode.closest('product-info');
    return [
      subtotalNode.dataset.sectionId,
      productInfo?.dataset?.section,
      productInfo?.dataset?.originalSection,
    ].filter(Boolean);
  };

  const initSubtotal = (subtotalNode) => {
    if (!subtotalNode || subtotalNode.dataset.subtotalReady === 'true') return;

    const productForm = subtotalNode.closest('product-form-component');
    const subtotalPriceEl = subtotalNode.querySelector('[data-subtotal-price]');
    if (!productForm || !subtotalPriceEl) return;

    const variants = parseVariants(subtotalNode);
    const sectionIds = getSectionIds(subtotalNode);

    const updateSubtotal = (variantOverride) => {
      const quantityInput = productForm.querySelector('.quantity__input');
      const variantInput = productForm.querySelector('input[name="id"]');
      if (!quantityInput) return;

      const quantity = Math.max(1, Number(quantityInput.value) || 1);
      let selectedVariant = variantOverride || getSelectedVariantFromPicker(subtotalNode);

      if (!selectedVariant && variantInput) {
        const selectedVariantId = String(variantInput.value || '');
        selectedVariant = variants.find((variant) => String(variant.id) === selectedVariantId);
      }

      if (!selectedVariant || selectedVariant.price == null) return;

      subtotalPriceEl.textContent = formatMoney(subtotalNode, selectedVariant.price * quantity);
    };

    productForm.addEventListener(
      'input',
      (event) => {
        if (event.target.matches('.quantity__input')) updateSubtotal();
      },
      true
    );

    productForm.addEventListener(
      'change',
      (event) => {
        if (event.target.matches('.quantity__input, input[name="id"]')) updateSubtotal();
      },
      true
    );

    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (payload) => {
        const eventSectionId = payload?.data?.sectionId;
        if (eventSectionId && !sectionIds.includes(eventSectionId)) return;
        updateSubtotal(payload?.data?.variant);
      });

      subscribe(PUB_SUB_EVENTS.quantityUpdate, () => {
        updateSubtotal();
      });
    }

    subtotalNode.dataset.subtotalReady = 'true';
    updateSubtotal();
  };

  window.initProductSubtotals = (root = document) => {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-product-subtotal]').forEach((subtotalNode) => {
      if (subtotalNode.dataset.subtotalReady === 'true') return;
      initSubtotal(subtotalNode);
    });
  };

  const boot = () => window.initProductSubtotals();
  boot();
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('product-info:loaded', (event) => {
    window.initProductSubtotals(event.target || document);
  });
})();
